export default "__VITE_ASSET__CMOksGKM__"